import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import LoginScreen from '../screens/Auth/LoginScreen'

const AuthStack = createStackNavigator()

function AuthNavigator(props) {
    return (
        <AuthStack.Navigator>
            <AuthStack.Screen
                name={'Auth'}
                component={LoginScreen}
                options={{
                    headerTransparent: true,
                    headerTitle: null,
                    headerLeft: null
                }}
            />
        </AuthStack.Navigator>
    )
}

export default AuthNavigator